export const useRootPage = () => {
  return 'modules';
};
